import httpClient from '~/modules/core/httpClient'
import { ACTIONS } from './common'

const url = {
  SETTINGS: '/users/settings/',
  USER_JOIN: '/organizations/users/join/',
  USER_PROFILE: '/users/update/',
  USER_EXPORT: '/users/export',
  USER_UPDATE_AVATAR: '/unification/users/avatar',
  TUTORIAL_DISMISS: '/users/tutorial-dismiss',
}

const updateSetting = (user_settings) =>
  httpClient.json.post(url.SETTINGS, { user_settings, action: ACTIONS.UPDATE })

const join = (invite_token) =>
  httpClient
    .create()
    .ejectRes('defaultResponseErrorHandler')
    .post(url.USER_JOIN, () => ({
      invite_token,
      action: ACTIONS.UPDATE,
    }))

const updateProfile = (params) =>
  httpClient.json.patch(url.USER_PROFILE, () => params)

const updateAvataProfile = (params) =>
  httpClient.patch(url.USER_PROFILE, params)

const updateAvatarUserInvite = (params) =>
  httpClient.post(url.USER_UPDATE_AVATAR, params)

const dismissTutorial = () =>
  httpClient.post(url.TUTORIAL_DISMISS, { tutorial_dismissed: true })

const userApi = {
  updateSetting,
  join,
  updateProfile,
  updateAvataProfile,
  updateAvatarUserInvite,
  dismissTutorial,
}

export default userApi
